import { isTokenExpired } from '../utils/jwtUtils'

const TOKEN_KEY = 'access_token'
const REFRESH_KEY = 'refresh_token'
const USER_KEY = 'user_profile'
// The dex-config `features` array submittals-service returns at sign-in and on
// every refresh. Stored with the tokens and cleared with them.
const FEATURES_KEY = 'features'

// localStorage can throw SecurityError in private/incognito mode or when quota is exceeded
const safeGet = key => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* quota exceeded or storage blocked */
  }
}

const safeRemove = key => {
  try {
    localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

export const tokenService = {
  getAccessToken: () => safeGet(TOKEN_KEY),
  getRefreshToken: () => safeGet(REFRESH_KEY),
  isAuthenticated: () => {
    const token = safeGet(TOKEN_KEY)
    return Boolean(token) && !isTokenExpired(token)
  },

  setTokens: ({ accessToken, refreshToken }) => {
    safeSet(TOKEN_KEY, accessToken)
    safeSet(REFRESH_KEY, refreshToken)
  },

  clearTokens: () => {
    safeRemove(TOKEN_KEY)
    safeRemove(REFRESH_KEY)
    safeRemove(USER_KEY)
    safeRemove(FEATURES_KEY)
  },

  setUser: user => {
    safeSet(USER_KEY, JSON.stringify(user))
  },

  // Anything but an array is stored as none, so a missing or malformed list reads
  // every flag as off rather than on.
  setFeatures: features => {
    safeSet(FEATURES_KEY, JSON.stringify(Array.isArray(features) ? features : []))
  },

  getFeatures: () => {
    try {
      const parsed = JSON.parse(safeGet(FEATURES_KEY) ?? '[]')
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  },

  getUser: () => {
    try {
      const raw = localStorage.getItem(USER_KEY)
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  },
}
